<template lang="pug">
div
	p.bold(style='margin-top:0px;margin-bottom:0px;')
		span(v-if='employee && employee.name')
			span.margin-right {{employee.name.first}}
			span.margin-right(v-if='employee.name.middle') {{employee.name.middle[0]}}.
			span.margin-right {{employee.name.last}}
			span(v-if='employee.name.suffix') {{employee.name.suffix}}
	p.cp-f-small.text-muted(style='margin-top:0px;margin-bottom:0px;')
		span(v-if='employee && employee.code') {{employee.code}} 
			span(v-if='employee && employee.code && employee.ssn') &middot; 
			span(v-if='employee && employee.ssn')
				span SSN: {{employee.ssn.slice(-4)}}
</template>

<script>
export default {
  name: "Employee",

  props: ["employee"],
  mounted: function() {}
};
</script>

<style scoped lang="less">
</style>
